import { z } from 'zod'

export const setUserInterestsSchema = z.object({
  genreIds: z
    .array(z.string())
    .min(1, 'Select at least 1 interest')
    .max(5, 'Select at most 5 interests'),
})

export const setClubGenresSchema = z.object({
  genreIds: z
    .array(z.string())
    .min(1, 'Select at least 1 genre')
    .max(3, 'Select at most 3 genres'),
})

export type SetUserInterestsInput = z.infer<typeof setUserInterestsSchema>
export type SetClubGenresInput = z.infer<typeof setClubGenresSchema>
